'use client';

import { cn } from '@/lib/utils';
import Link from 'next/link';

export default function TextLinkItem({
  linkDestination,
  linkIcon,
  linkText,
  openInNewTab = false,
  isDownload = false,
}: {
  linkDestination: string;
  linkIcon: React.ReactNode;
  linkText: string;
  openInNewTab?: boolean;
  isDownload?: boolean;
}) {
  return (
    <Link
      className={cn(
        `flex
        items-center
        gap-2
        transition-colors
        hover:text-black/70
        dark:hover:text-white/70`,
      )}
      href={linkDestination}
      target={openInNewTab ? '_blank' : ''}
      rel="noopener noreferrer"
      download={isDownload}
    >
      {linkIcon}
      {linkText}
    </Link>
  );
}
